import { render, staticRenderFns } from "./InternetAccessPrintPage.vue?vue&type=template&id=79cb18bd"
import script from "./InternetAccessPrintPage.vue?vue&type=script&lang=js"
export * from "./InternetAccessPrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports